import {Component, EventEmitter, Input, Output} from "@angular/core";
import {NgForOf, NgIf} from "@angular/common";
import {NgbDropdown, NgbDropdownMenu, NgbDropdownToggle} from "@ng-bootstrap/ng-bootstrap";
import {TranslateModule} from "@ngx-translate/core";
import {ReferentielTelephone} from "@app/mon-compte/models/ReferentielTelephone.model";


@Component({
    selector: 'ned-btn-indicatif-telephonique',
    templateUrl: './btn-indicatif-telephonique.component.html',
    styleUrls: ['./btn-indicatif-telephonique.component.scss'],
    standalone: true,
    imports: [
        NgForOf,
        NgbDropdown,
        NgbDropdownMenu,
        NgbDropdownToggle,
        TranslateModule,
        NgIf
    ]
})
export class BtnIndicatifTelephoniqueComponent {

    @Input() listeIndicatif: ReferentielTelephone[] = [];
    @Input() indexIndicatif: number | undefined = -1;

    @Output() choixIndicatifTelephonique = new EventEmitter<{indicatif: ReferentielTelephone, index: number}>();

    onClickIndicatif(indicatif: ReferentielTelephone, index: number) {
        this.choixIndicatifTelephonique.emit({indicatif, index});
    }

    trackById(index: number, item: ReferentielTelephone) {
        return item.id;
    }

}
